import type { ProductRepositorySearchOptions } from "../../_Bases/BaseProductRepository";

/**
 * Get the search options for the product repositories
 */
export const getProductRepositorySearchOptions = (
    options?: Partial<ProductRepositorySearchOptions>
): ProductRepositorySearchOptions => {
    const defaultOptions: ProductRepositorySearchOptions = {
        name         : true,
        barcode      : true,
        exactMatch   : false,
        exact        : false, // TODO: Remove
        quantityCheck: false,
        quantityCount: 0,
        filter       : undefined,
        sort         : false,
        limit        : Infinity,
    };

    let newOptions;

    if(options) {
        newOptions = Object.assign({}, defaultOptions, options);
    } else {
        newOptions = defaultOptions;
    }

    if(!newOptions.name && !newOptions.barcode) {
        throw new Error("Not searching for anything");
    }

    return newOptions;
};
